import { useState } from 'react'
import { styled } from '@/src/stitches.config'
import Button from '../../../common/components/marketing/buttons/Button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogTitle,
} from '@/src/common/components/elements/Modals/Modal'
import usePostOrderCancel from '../../../common/hooks/usePostOrderCancel'
import LinkButton from '../../../common/components/marketing/buttons/LinkButton'
import { FAQ_TEXT } from '@/src/modules/cardholder/VirtualRedemption/strings'
import { FAQ_PAGE } from '../../pg-plus/constants'

const TriggerWrapper = styled('div', {
    display: 'flex',
    jc: 'center',
    cursor: 'pointer',
})
const Flex = styled('div', { display: 'flex' })

const successText =
    'Your order has been successfully cancelled. The authorization hold made' +
    ' for the order has been cancelled. This order will not be captured or' +
    ' processed.'
const errorText =
    'Unfortunately your order was not able to be successfully cancelled. We apologize for the inconvenience. Please click Chat Now to talk with our GiftGuide for further assistance.'

interface OrderCancelModalProps {
    orderUuid: string
}

const OrderCancelModal = (props: OrderCancelModalProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const { mutate, isLoading, isSuccess, isError } = usePostOrderCancel()
    const { orderUuid } = props

    return (
        <>
            <TriggerWrapper
                onClick={() => setIsOpen(!isOpen)}
                data-testid={'modal-trigger'}
            >
                <Button
                    label={'Cancel Order'}
                    onClick={() => setIsOpen(true)}
                />
            </TriggerWrapper>
            <Dialog open={isOpen}>
                <DialogContent
                    data-testid="order_cancel_modal"
                    width={'extra-small'}
                >
                    <DialogTitle css={{ textAlign: 'center' }}>
                        {!isError && !isSuccess && 'Are you sure?'}
                        {isSuccess && 'Thank you'}
                    </DialogTitle>
                    <DialogDescription>
                        {isSuccess && <p>{successText}</p>}
                        {isError && (
                            <>
                                <p>{errorText}</p>
                                <LinkButton
                                    label={FAQ_TEXT}
                                    variant={'primaryOutline'}
                                    url={FAQ_PAGE}
                                />
                            </>
                        )}
                    </DialogDescription>

                    <Flex
                        css={{
                            justifyContent: 'center',
                            marginTop: 25,
                            gap: '1rem',
                        }}
                    >
                        {!isSuccess && !isError && (
                            <>
                                <Button
                                    variant={'primaryOutline'}
                                    size={'sm'}
                                    label={'Yes'}
                                    type={'button'}
                                    onClick={() => mutate({ uuid: orderUuid })}
                                    showArrow={false}
                                    isLoading={isLoading}
                                    disabled={isLoading}
                                    width={'full'}
                                />
                                <Button
                                    variant={'primaryOutline'}
                                    size={'sm'}
                                    label={'No'}
                                    type={'button'}
                                    onClick={() => setIsOpen(false)}
                                    showArrow={false}
                                    disabled={isLoading}
                                    width={'full'}
                                />
                            </>
                        )}
                        {isSuccess && (
                            <Button
                                variant={'primaryOutline'}
                                size={'sm'}
                                label={'Ok'}
                                type={'button'}
                                onClick={() => window.location.reload()}
                                showArrow={false}
                                width={'standard'}
                            />
                        )}
                    </Flex>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default OrderCancelModal
